import React, { useState } from "react";

import { makeStyles, Box, Grid, Typography, Modal } from "@material-ui/core";

import { ToInstall } from "./ToInstall";
import { COLORS } from "../../../../theme/colors";
import { ConnectTenants } from "../../../../components/connectTenants";
import { ShaDowBox } from "../../../../components/boxes";
import { TenancyParameters } from "./TenancyParameters";

const useStyles = makeStyles((theme) => ({
  revenueBySource: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
    color: COLORS.red,
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const Content = React.forwardRef((props, ref) => (
  <ConnectTenants {...props} innerRef={ref} />
));

export const BreakDownBySource = () => {
  const classes = useStyles();
  const [connectTenantsModal, setConnectTenantsModal] = useState(false);

  return (
    <Box>
      <Typography className={classes.revenueBySource} variant="h4">
        Unrealized Revenues Breakdown By Source
      </Typography>
      <ShaDowBox style={{ marginBottom: 35 }}>
        <Grid container>
          <TenancyParameters setConnectTenantsModal={setConnectTenantsModal} />
          <ToInstall />
        </Grid>
      </ShaDowBox>

      {/* Model for connecting unconnected tenants */}
      <Modal
        className={classes.modal}
        open={connectTenantsModal}
        onClose={() => setConnectTenantsModal(false)}
      >
        <Content onClose={() => setConnectTenantsModal(false)} />
      </Modal>
    </Box>
  );
};
